import type { FunctionComponent } from 'react';

import { PLATFORM } from '@/domains/core/settings/constants';

interface Paypal4xLabelContentProps {
  className?: string;
  amount?: number;
}

export const Paypal4xLabelContent: FunctionComponent<
  Paypal4xLabelContentProps
> = ({ className, amount }) => (
  <div className={className}>
    <div
      data-pp-message
      data-pp-style-logo-type="alternative"
      data-pp-placement="product"
      data-pp-style-layout="text"
      data-pp-style-text-size="14"
      data-pp-style-text-align="center"
      data-pp-amount={amount}
      data-pp-buyercountry={PLATFORM.toUpperCase()}
    />
  </div>
);
